import { NavigationGuard } from 'vue-router';
import { useAuth0 } from '@auth0/auth0-vue';

const hasRequiredRoles = (requiredRoles: string[], userRoles: string[]): boolean => {
  if (!requiredRoles || requiredRoles.length === 0) return true;
  // Admin always has access
  if (userRoles.includes('admin')) return true;
  // Check if user has any of the required roles
  return requiredRoles.some(role => userRoles.includes(role));
};

export const authGuard: NavigationGuard = async (to) => {
  const { isAuthenticated, loginWithRedirect, user } = useAuth0();

  // Don't apply guard to callback route
  if (to.path === '/callback') {
    return true;
  }

  if (to.meta.requiresAuth && !isAuthenticated.value) {
    await loginWithRedirect({
      appState: { 
        targetUrl: to.fullPath
      },
      authorizationParams: {
        redirect_uri: `${window.location.origin}/callback`
      }
    });
    return false;
  }

  // Check for required roles
  if (to.meta.requiredRoles && isAuthenticated.value) {
    const roles = user.value?.[`${import.meta.env.VITE_ZERO_AUDIENCE}/roles`] || [];
    if (!hasRequiredRoles(to.meta.requiredRoles as string[], roles)) {
      return { name: 'landing' }; // Redirect to landing page if user doesn't have required roles
    }
  }

  return true;
};